<template>
    <div class="page">
      <Header title="创建订单" :show-back="true" />
      <div class="order-box">
        <div class="order-box-address">
          <div class="box-title">请选择地址</div>
          <van-radio-group v-model="address" v-for="item in addressList" :key="item.addressId">
            <van-radio :name="item.addressId">
              <div>{{ item.provinceName }}{{ item.cityName }}{{ item.countyName }}{{ item.detailAddress }}</div>
              <div>{{ item.contactPerson }} &nbsp; &nbsp;{{ item.contactMobile }}</div>
            </van-radio>
          </van-radio-group>
        </div>
        <div class="order-box-item">
          <div class="item-img">
            <img :src="getImageUrl(giftImg)">
          </div>
          <div class="item-info">
            <div>{{ giftInfo.itemName }}</div>
            <div class="gift-pointer">{{ giftInfo.firstPointTypeName }}:<span style="font-size: 18px;">{{ giftInfo.exchangePoint }}</span></div>
          </div>
          <div class="item-amount">
            <van-stepper v-model="itemAmount" integer :min="1" :max="1" input-width="26px" disabled/>
          </div>
        </div>
      </div>
      <div class="btn-row">
        <div class="integral-area">
          {{ giftInfo.firstPointTypeName }}:{{ giftInfo.exchangePoint }}
        </div>
        <van-button type="primary" size="large" @click="submitExchange">立即兑换</van-button>
      </div>

      <!-- 弹窗 -->
      <van-popup v-model="popShow" class="msg-pop" :close-on-click-overlay="false">
        <div class="msg-title">恭喜你</div>
        <div class="msg-text">兑换成功!</div>
        <div class="msg-btn">
          <van-button type="primary" size="large" @click="popCancel">确定</van-button>
        </div>
      </van-popup>
    </div>
</template>

<script>
import Header from '@/components/header'
import activityApi from '@/api/activity'
import { userUtils } from '@/utils/auth'
import { commonUtils } from '@/utils/common'
export default {
  name: 'ActivityDragonOrder',
  components: {
    Header
  },
  data () {
    return {
      addressList: [],
      itemAmount: 1,
      address: '',
      itemCode: '',
      scanCode: '',
      giftInfo: {},
      giftImg: '',
      popShow: false
    }
  },
  created () {
    let url = this.$route.name
    let clientInfo = userUtils.getClientInfo()
    if (!clientInfo) {
      this.$router.push({
        name: 'login',
        params: { redirectUrl: url }
      })
      return
    }
    this.getAddressList()
    this.itemCode = 'G170378'
    this.getGiftInfo()
  },
  methods: {
    // 获取收货地址
    getAddressList () {
      activityApi.getAddressList().then(res => {
        if (res.data.resultCode === '0') {
          this.addressList = res.data.resultData.addressList
        }
      })
    },
    // 获取礼品信息
    getGiftInfo () {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true
      })
      activityApi.getGiftInfo(this.itemCode).then(res => {
        if (res.data.resultCode === '0') {
          this.$toast.clear()
          if (res.data.resultData.imageList.length) {
            this.giftImg = res.data.resultData.imageList[0].fileUri
          }
          this.giftInfo = res.data.resultData.itemInfo
        }
      })
    },
    // 兑换
    submitExchange () {
      if (!this.address) {
        this.$toast('请选择地址')
        return false
      }
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '兑换中'
      })
      let formData = {
        addressId: this.address,
        itemId: this.giftInfo.itemId,
        itemQuantity: this.itemAmount
      }
      activityApi.createCMOrder(formData).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          this.popShow = true
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },

    popCancel () {
      this.popShow = false
      this.$router.push({ name: 'activity-dragon-boat' })
    },

    // 图片
    getImageUrl (imageUri) {
      return commonUtils.getImageUrl(imageUri)
    }
  }
}
</script>

<style lang="less" scoped>
.order-box {
  background-color: #fff;
  margin: 10px 8px;
  padding: 15px 10px;
  border-radius: 5px;
  .box-title {
    color: #8fb2b8
  }
  .van-radio {
    margin-top: 15px;
  }
  .order-box-address {
    padding-bottom: 16px;
    border-bottom: solid 1px #ccc
  }
}
.btn-row {
  height: 49px;
  width: 100%;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  display: flex;
  .integral-area {
    width: 130px;
    line-height: 49px;
    text-align: center;
    color: #117281;
  }
  .van-button {
    border-radius: 0;
    width: calc(100% - 130px);
  }
}
.order-box-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 8px;
  .item-img  {
    width: 90px;
    height: 90px;
    display: flex;
    align-items: center;
  }
  .item-info {
    width: calc(100% - 220px);
  }
  .gift-pointer {
    margin-top: 35px;
    color: #f63b2e
  }
}
img {
  max-width: 100%;
  max-height: 100%;
}
.msg-pop {
  width: 200px;
  height: 140px;
  border-radius: 5px;
  text-align: center;
  .msg-title {
    font-size: 18px;
    margin-top: 20px;
    color: #402d26;
  }
  .msg-text {
    font-size: 16px;
    margin-top: 15px;
    color: #402d26;
  }
  .msg-btn {
    display: flex;
    justify-content: center;
    margin-top: 16px;
    .van-button--large {
      width: 75px;
      height: 35px;
      line-height: 35px;
      font-size: 16px;
      margin: 0 8px;
    }
  }
}
</style>
